import { AlignItems, JustifyContent } from "types/generic/types";

interface GetJustifyContentClassNamesProps {
  justifyContent?: JustifyContent;
}

export const getJustifyContentClassNames = ({
  justifyContent,
}: GetJustifyContentClassNamesProps) => ({
  [`justify-content-${justifyContent}`]: !!justifyContent,
});

interface GetAlignItemsClassNamesProps {
  alignItems?: AlignItems;
}

export const getAlignItemsClassNames = ({
  alignItems,
}: GetAlignItemsClassNamesProps) => ({
  [`align-items-${alignItems}`]: !!alignItems,
});
